// 用户相关信息仓库

import { loginByUsername, logout, getUserMenu, getInfoByUser } from '@/api/login'
import {
  getToken, setToken,
  removeUserInfo, setUserId,
  getUserId, setUserName,
  getUserName,setUserFunction, getUserFunction
} from '@/utils/auth'
import {clearData} from "./clearData";

const user = {
  state: {
    token: getToken(),
    id: getUserId(),
    name: getUserName(),
    userFunction: getUserFunction(),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER_ID: (state, id) => {
      state.id = id;
    },
    SET_USER_NAME: (state, name) => {
      state.name = name;
    },
    SET_USER_FUNCTION: (state, userFunction) => {
      state.userFunction = userFunction
    }
  },

  actions: {
    SetUserToken({commit},params) {
      setToken(params);
      commit('SET_TOKEN', params);
    },
    SetUserId({commit},params) {
      setUserId(params);
      commit('SET_USER_ID', params);
    },
    SetUserName({commit},params) {
      setUserName(params);
      commit('SET_USER_NAME', params);
    },
    // 用户可用功能
    SetUserFunction({commit},params) {
      setUserFunction(params);
      commit('SET_USER_FUNCTION', params);
    },
    // 用户名登录
    LoginByUsername({ commit }, params) {
      return new Promise((resolve, reject) => {
        loginByUsername(params).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },
    // 获取用户菜单
    GetUserMenu({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = {};
        params.modelId = '0';
        getUserMenu(params).then(res => {
          if(res.data.status == 200){
            resolve(res.data.data);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },

    // 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        clearData();
        resolve();
      })
    },
    // 清空本地信息
    ClearUser({ commit }){
      commit('SET_USER_NAME', '');
      commit('SET_USER_ID', '');
      commit('SET_TOKEN', '');
      commit('SET_USER_FUNCTION', '');
      removeUserInfo();
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js